<script>
import { mapGetters } from 'vuex';
import config from '@/config';
import TweenMax, {Expo} from 'gsap/TweenMax';
import UiButton from '@/components/ui/Button';

export default {
  name: 'Prelude',
  components: {
    UiButton
  },
   data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      locale: 'I18n/locale',
    }),
    contents() {
      if(this.$route.params.id === undefined) return null;

      return this.$t(`preludes.${this.$route.params.id}`);
    },
    progressionLevel() {
      return config.PRELUDES_DATA[this.$route.params.id].index;
    }
  },
  mounted() {
    
    TweenMax.staggerFrom(this.$el.querySelectorAll('.progress'), 1, {scale:0, clearProps:'all', alpha:0, ease:Expo.easeOut, delay:1.5}, 0.15);
    TweenMax.staggerFrom(this.$el.querySelectorAll('.text'), 2, {y:20, alpha:0, ease:Expo.easeOut}, 1);
    
    TweenMax.from(this.$el.querySelector('.next-buttton'), .5, {alpha:0, y:20, ease:Expo.easeOut, delay: this.contents.length * 1});
  },
  methods: {
    exit(){
      TweenMax.to(this.$el.querySelector('.panel'), 2, {alpha:0, ease:Expo.easeOut, onComplete: () => {
        this.$router.push({name:config.PRELUDES_DATA[this.$route.params.id].route + this.locale.toUpperCase()});
      }});
    },
  },
}
</script>

<template>
  <div :class="['Prelude', $route.params.id === 'death' ? '-death' : '']">
    <div class='panel'>
      <ul class='progression'>
        <li v-for="i in 5" :key="i" class='progressionLI'>
          <template v-if="$route.params.id === 'death'">
            <template v-if="i === progressionLevel">
              <img src='/assets/progress/progression-full-death-svg.png' class='progress' />
            </template>
            <template v-else>
              <img src='/assets/progress/progression-empty-death-svg.png' class='progress' />
            </template>
          </template>
          <template v-else>
            <template v-if="i === progressionLevel">
              <img src='/assets/progress/progression-full-svg.png' class='progress' />
            </template>
            <template v-else>
              <img src='/assets/progress/progression-empty-svg.png' class='progress' />
            </template>
          </template>
        </li>
      </ul>
      <div class='texts' v-if="contents">
        <div class='text' v-for="(content, index) in contents" :key="`content-${index}`" v-html="content" />
      </div>
      <ui-button
        ref="Exit"
        :opacity="$route.params.id === 'death' ? 1 : .5"
        :color="$route.params.id === 'death' ? '#00262a' : '#31CAAF'"
        class="next-buttton" v-on:pressed="exit" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.Prelude {
  position: relative;
  width: 100%;
  height: calc(100% - #{$header-height});
  margin: 0px;
  @include flexbox(center-vertical);

  @include ipad(landscape) {
    display: none;
  }

  &.-death {
    background-color: $c-white;

    .panel {
      .text {
        color: #00262a;
      }
    }

    .progress {
      stroke: #00262a;
    }
  }
}

.panel {
  width: 80%;
  height: 60%;
  text-align: center;
  @include flexbox(column, null, space-between, center);

  .text {
    margin: 2px;
    padding: 0px;
    color: $c-shamrock;
    font-size: 1.1rem;

    &:last-child {
      margin-top: 25px
    }
  }
}

.progression {
  @include flexbox(row, null, center);
  margin: 0;
  padding: 0;
  list-style-type: none;

  .progressionLI {
    margin-right: 8px;

    &:last-child {
      margin-right: 0px;
    }
  }

  .progress {
    width: 11px;
    height: 100%;

    @include ipad {
      width: 20px;
    }
  }
}

.next-buttton {
  width: 45px;
  height: auto;

  @include ipad {
    width: 70px;
  }
}
</style>
